import { useParams } from 'next/navigation'

import { useQuery } from '@tanstack/react-query'

import { ProductViewModel } from '@/types/api'

import { QueryKeys } from '@/app/_utils/react-query'

import { getPDPData } from './get-pdp-data'

export default function usePDPData(initialSlug?: string) {
    const params = useParams()

    let slug = ''

    if (initialSlug) {
        slug = initialSlug
    } else {
        slug = typeof params?.slug === 'string' ? params?.slug : (params?.slug?.at?.(0) ?? '')
    }

    return useQuery<ProductViewModel>({
        queryKey: QueryKeys.PDP.ProductData(slug),
        staleTime: Infinity,
        queryFn: () => getPDPData(slug),
        refetchOnMount: false,
        enabled: !!slug,
    })
}
